module.exports = __webpack_public_path__ + "img/17855_L.081ab548.png";